import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthStateService } from '../../core/services/auth-state.service';

@Directive({ selector: '[appHasPermission]' })
export class HasPermissionDirective {
  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef,
    private auth: AuthStateService
  ) {}

  @Input() set appHasPermission(keys: string | string[]) {
    let allowed = false;

    if (Array.isArray(keys)) {
      allowed = this.auth.hasAny(keys);
    } else {
      allowed = this.auth.hasPermission(keys);
    }

    this.updateView(allowed);
  }

  private updateView(show: boolean) {
    this.vcr.clear();
    if (show) {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }
}
